//
//
//
//
//
//
//

import { mapGetters, mapActions } from 'vuex';
export default {
  components: {
  },
  name: 'imageView',
  data() {
    return {
      files: [
        {
          url: '75344414_p0min2.jpg',
          fileId: '1',
        }
      ]
    }
  },
  methods: {
    getFile() {
      console.log(this.$refs.frimageView.fileList)
    }
  },
  watch: {
  },
  computed: {
    ...mapGetters([
      'crfcode',
      'baseURL'
    ])
  },
  created() {
  },
  mounted() {
  }
};
